import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { blobToFile } from "../../utils"
import adapter from "./adapter"
import service, { getIdFromResponse } from "./service"

const NAME = 'blog'

const initialData = {
  gallery_saved: []
}

const initialState = {
  _payload: null,
  status: "idle",
  message: "",
  error: "",
  data: initialData,
};

export const fetchBlog = createAsyncThunk(
  `${NAME}/fetchBlog`,
  async (id) => await service.get(id)
);

export const createBlog = createAsyncThunk(
  `${NAME}/api/createBlog`,
  async (data) => {
    console.log('create blog data:', data)
    const needToHandleGallery = data.gallery && data.gallery.length > 0
    const needToHandleGalleryDelete = data.gallery_holder_delete && data.gallery_holder_delete.length > 0

    return await service.create(data).then((res) => {
      console.log('create blog response:', res)
      let id = getIdFromResponse(res)

      if(id){
        const promise1 = service.handleImage(id, data)
        const promise2 = needToHandleGallery ?
          service.handleGallery(id, data) : false
        const promise3 = needToHandleGalleryDelete ? service.handleGalleryDelete(data.gallery_holder_delete) : false

        return Promise.all([promise1, promise2, promise3]).then((values) => {
          console.log(values);
        })
      }else{
        return res
      }
    })
  }
);

export const updateBlog = createAsyncThunk(
  `${NAME}/api/updateBlog`,
  async ({ id, form }) => {
    const needToHandleGallery = form.gallery && form.gallery.length > 0
    const needToHandleGalleryDelete = form.gallery_holder_delete && form.gallery_holder_delete.length > 0

    const promises = []

    const promise1 = await service.update(id, form)
    promises.push(promise1)
    const promise2 = service.handleImage(id, form)
    promises.push(promise2)

    if(needToHandleGallery){
      let filesByBlob = {}
      for (let index = 0; index < form.gallery.length; index++) {
        const { blob, name, type } = form.gallery[index];
        const file = await blobToFile(blob, name, type)
        filesByBlob[blob] = file
      }

      const promise3 = service.handleGallery(id, filesByBlob)
      promises.push(promise3)
    }

    if(needToHandleGalleryDelete){
      const promise4 = service.handleGalleryDelete(form.gallery_holder_delete)
      promises.push(promise4)
    }

    return Promise.all(promises).then((values) => {
      console.log({values});
      return promise1
    })
  }
);

export const blogSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    updateForm(state, action){
      state.data[action.payload.key] = action.payload.value
    },
    reset(state){
      state.data = initialData
    }
  },
  extraReducers: {
    [fetchBlog.pending]: (state) => {
      state.status = "loading";
    },
    [fetchBlog.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const blog = action.payload.results;
      state.data = adapter.responseBodyToRender(blog);
    },
    [fetchBlog.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },

    [createBlog.pending]: (state) => {
      state.status = "loading";
      state.message = "Creating blog..."
    },
    [createBlog.fulfilled]: (state) => {
      state.status = "idle";
      state.message = "Blog sucessfully created."
    },
    [createBlog.pending]: (state) => {
      state.status = "idle";
      state.message = "Blog failed to create."
    },
  }
});

export const {
  setStatus,
  updateForm,
  reset
} = blogSlice.actions

export default blogSlice.reducer;
